import { useState, useEffect } from "react";
import { EChartsOption } from "echarts-for-react";
import { localeDate } from "../../../../app/datetimeUtils";
import { scoreReportEssayLink } from "../../../../app/links";
import SimpleListbox from "../../../../components/input/SimpleListbox";
import { TraitChartFilter, TraitScoreEChart } from "../../course/performance/TraitScoreChart";
import { CrTraitScoreWithNormsViewModel, CrTraitScoreViewModel } from "./performanceReportApiSlice";

export const crTraits: TraitChartFilter[] = [
	{ value: "totalScore", label: "Holistic/Total", maxValue: 3 },
	{ value: "textualEvidenceScore", label: "Textual Evidence", maxValue: 3 },
	{ value: "contentAccuracyScore", label: "Content Accuracy", maxValue: 3 },
];

export const crOptions = crTraits.map((t) => ({ value: t.value, label: t.label }));

export function CrTraitScoreChart(props: {
	className?: string;
	scores: CrTraitScoreWithNormsViewModel[];
	averages: CrTraitScoreViewModel;
}) {
	const getData = (filter: TraitChartFilter) => {
		const data = props.scores.map((data) => {
			const value = data[filter.value as keyof CrTraitScoreWithNormsViewModel];
			return {
				name: data.promptName + "\n" + localeDate(data.date),
				value: value != null ? Number(value) : null,
				link: scoreReportEssayLink(data.essayId),
			};
		});
		return data.find((d) => d.value !== null) ? data : [];
	};

	const getAverage = (filter: TraitChartFilter) => {
		return props.averages[filter.value as keyof CrTraitScoreViewModel];
	};

	const [selected, setSelected] = useState(crTraits[0]);

	useEffect(() => {
		const trait = crTraits.find((t) => t.value === selected.value) ?? crTraits[0];
		setSelected(trait);
	}, [selected]);

	const options: EChartsOption = {
		xAxis: {
			name: `${selected.label} Score`,
		},
	};

	if (!props.scores || props.scores.length == 0) return "";

	return (
		<div className={props.className ?? ""}>
			<SimpleListbox
				id="viewFilter"
				options={crOptions}
				value={selected.value}
				className="w-1/6"
				onChange={(e) =>
					setSelected(crTraits.find((t) => t.value === e.target.value) ?? crTraits[0])
				}
			/>

			<TraitScoreEChart
				data={getData(selected)}
				dataLabel={selected.label}
				average={getAverage(selected)}
				averageLabel="Student"
				maxValue={3}
				options={options}
			/>
		</div>
	);
}
